export const safeTrim = (value) => {
  if (typeof value !== "string") {
    return "";
  }

  return value.trim();
};

export const sanitizeInput = (value) => {
  return safeTrim(value)
    .replace(/[<>]/g, "");
};

export const isAdminUser = (user) => {
  const configuredAdminEmail = safeTrim(process.env.REACT_APP_ADMIN_EMAIL).toLowerCase();
  const userEmail = safeTrim(user?.email).toLowerCase();

  return Boolean(configuredAdminEmail && userEmail && userEmail === configuredAdminEmail);
};
